module.exports = __webpack_public_path__ + "static/golden-gate-424e8a11a174b469ba2cf5135cc04e96.mp4";